var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrangeFolderIcon = function SvgOrangeFolderIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.762,
    height: 18,
    viewBox: "0 0 21.762 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff7900",
    d: "M21.742 8.512c0-.029.016-.053.016-.082V5a3 3 0 0 0-3-3H7.829A3.01 3.01 0 0 0 5 0H3a3 3 0 0 0-3 3v12c0 .027.013.049.015.076a2.68 2.68 0 0 0 .535 1.72 3.06 3.06 0 0 0 2.46 1.2h13.854a2.99 2.99 0 0 0 2.887-2.053L21.66 9.58a2.7 2.7 0 0 0 .082-1.068M3 2h2a1 1 0 0 1 1 1 1 1 0 0 0 1 1h11.758a1 1 0 0 1 1 1v1.177A3.1 3.1 0 0 0 18.773 6H4.919a2.99 2.99 0 0 0-2.888 2.052l-.031.1V3a1 1 0 0 1 1-1m16.744 7.009-1.909 6.364a.99.99 0 0 1-.971.627H3.01a1.06 1.06 0 0 1-.855-.4.68.68 0 0 1-.117-.612l1.909-6.364a1 1 0 0 1 .972-.627h13.854a1.06 1.06 0 0 1 .855.4.67.67 0 0 1 .116.612",
    "data-name": "Path 890"
  })));
};
export default SvgOrangeFolderIcon;